// Guided tours seen — the views whose tour was offered or taken, kept per
// device (the impure half; the model is pure, components/GuidedTour/
// viewTours.ts).
//
// It keeps the offer quiet: each view offers its tour once, and a reload
// never brings the offer back. The design says per person; there is no
// server-side preference store yet, so like the Projects view and the pins
// this is DEVICE state (memory project_theme_outside_event_log): its own
// key, never a domain event. Read once, advanced only through its fold,
// written back on every change. Only the host (CoachHost) uses it.
//
// Taken is the narrower set: the views whose tour the author started. Until
// then the Help menu marks the tour New (pen's New badge: gone once seen).
// The same model, its own key.

export { useToursSeen, useToursTaken };

import { useSyncExternalStore } from "react";
import {
    foldToursSeen,
    parseToursSeen,
    serializeToursSeen,
    type ToursSeen,
    type ToursSeenCommand,
} from "../components/GuidedTour/viewTours.js";
import { mkDeviceFoldStore } from "./deviceStore.js";

const store = mkDeviceFoldStore<ToursSeen, ToursSeenCommand>(
    "bilda.toursSeen",
    parseToursSeen,
    serializeToursSeen,
    foldToursSeen,
);

const taken = mkDeviceFoldStore<ToursSeen, ToursSeenCommand>(
    "bilda.toursTaken",
    parseToursSeen,
    serializeToursSeen,
    foldToursSeen,
);

type ToursHook = () => readonly [ToursSeen, (cmd: ToursSeenCommand) => void];

const hookOf =
    (s: typeof store): ToursHook =>
    () => [useSyncExternalStore(s.subscribe, s.get), s.dispatch];

const useToursSeen = hookOf(store);
const useToursTaken = hookOf(taken);
